import { IOrdersState } from "./reducer";

const initialState: IOrdersState = {
  orders: [],
  isLoading: false,
  isUpdating: false,
};

export default initialState;
